import Link from '@mui/material/Link';

export function ExternalLink({ url, text, target }: any) {
  if (!target) {
    target = '_blank';
  }

  return (
    <Link href={url ?? '#'} target={target ?? ''}>
      {(text ?? '').length > 0 ? text : url ?? ''}
    </Link>
  );
}
